import React, { type ReactNode } from "react";

import clsx from "clsx";
import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

export const createSearchHighlightedLabel = (label: string, search: string) => {
  if (!search) {
    return { __html: label };
  }

  const escapedSearchText = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const searchHighlightedLabel = label.replace(
    new RegExp(escapedSearchText, "gi"),
    (match) => `<strong>${match}</strong>`,
  );
  return { __html: searchHighlightedLabel };
};

export const renderChevronAnimation = (
  open: boolean,
  isLoading?: boolean,
  icon?: ReactNode,
  className?: string,
) => {
  if (isLoading) {
    return (
      <i
        data-testid="select-loading-icon"
        className="spinner-border spinner-border-sm"
      />
    );
  } else if (icon) {
    return icon;
  }

  return (
    <motion.i
      initial={false}
      animate={{ rotate: open ? 0 : 180 }}
      transition={{ duration: 0.2 }}
      className={twMerge(
        clsx("fa-regular fa-sharp fa-chevron-up", { "text-v2-action": open }),
        className,
      )}
    />
  );
};
